import { mapContentBlocks, SharingEvent } from '@news-mono/web-common'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import React, { FC } from 'react'
import { Logger } from 'typescript-log'
import { ArticleBlockContent } from '../../ArticleBlockContent/ArticleBlockContent'
import { Byline } from '../../Byline/Byline'
import {
    StyledLiveEventArticleBlockContent,
    StyledLiveEventPost,
    StyledLiveEventSocialIcons,
    StyledLiveEventTitle,
} from './LiveEventPost.styled'

export interface LiveEventPostProps {
    post: EventPostV4DTO
    eventTitle: string
    log: Logger
    adUnitPath: string
    lazyLoadRef: React.RefObject<HTMLDivElement> | undefined
    onEvent: (event: SharingEvent) => void
}

export const LiveEventPost: FC<LiveEventPostProps> = ({
    post,
    eventTitle,
    log,
    adUnitPath,
    lazyLoadRef,
    onEvent,
}) => {
    const authorName =
        post.profiles.length >= 1
            ? post.profiles.map((profile) => profile.name).join(' &')
            : post.byline

    return (
        <StyledLiveEventPost ref={lazyLoadRef} key={post.id} id={post.id}>
            <Byline
                profile={post.profiles}
                publicationKind={post.kind}
                timestamp={post.publishedDate}
                isFullWidth={true} //
                allowCommenting={false}
                fundingType={undefined}
                text={authorName || undefined}
            ></Byline>
            {post.title && (
                <StyledLiveEventTitle>{post.title}</StyledLiveEventTitle>
            )}
            <StyledLiveEventArticleBlockContent>
                <ArticleBlockContent
                    blocks={mapContentBlocks(post.content.blocks)}
                    onEvent={() => {}}
                    log={log}
                    adUnitPath={adUnitPath}
                    publicationKind={'event'}
                />
            </StyledLiveEventArticleBlockContent>
            <StyledLiveEventSocialIcons
                url={post._self}
                text={post.title || eventTitle}
                onEvent={onEvent}
                shareOptions={['twitter', 'facebook', 'clipboard']}
                customCampaign="liveblog"
                publicationId={post.eventId}
                postId={post.id}
            />
        </StyledLiveEventPost>
    )
}
